export function IngredientEditSectionTitle({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <h2 className="text-xl font-bold mb-4 h-10 flex items-center">
      {children}
    </h2>
  );
}
